import { Component, Input, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { LoggingService } from '@services/logging.service';
import { LookupService } from '@services/lookup.service';
import { Study } from '@models/study.model';
import * as Constants from '@shared/_constants';
import { FilterUtilService } from '../shared/filter-util.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { SearchStrategyService } from '../../../services/search-strategy.service';

@Component({
  selector: 'app-filter-year-of-incorporation',
  templateUrl: './filter-year-of-incorporation.component.html',
  styleUrls: ['./filter-year-of-incorporation.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FilterYearOfIncorporationComponent implements OnInit {
  @Input() filter: any;
  public showLoader: boolean;
  @Input() readOnly: boolean;
  public study: Study;
  formDirty = false;
  yearOfIncorporationOptions: number[];
  disablePassIfNa = false;

  constructor(
    private lookupService: LookupService,
    private logger: LoggingService,
    private filterUtilService: FilterUtilService,
    private searchStrategyService: SearchStrategyService
  ) {}

  ngOnInit() {
    this.loadInitialData();
    this.setPassIfNaOption();
  }

  loadInitialData() {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_NGONINIT, Constants.LoggerMessages.LOGGER_START);
    this.yearOfIncorporationOptions = [];
    this.yearOfIncorporationOptions = this.lookupService.getYearList(50);
  }

  CheckEndGreaterThanBeginning(beginning: string, ending: string): boolean {
    return this.filterUtilService.checkEndGreaterThanBeginning(beginning, ending);
  }

  ShowValidationMessage(item: NgModel): boolean {
    return (item.errors || false) && (!item.pristine || item.touched);
  }

  private setPassIfNaOption(): void {
    if (this.searchStrategyService.studySearchStrategy.studySearchStrategyDatabases.length === 1) {
      return;
    }

    this.disablePassIfNa = true;
    this.filter.includeYearNotKnown = true;
  }
}
